
export default {
  API_HOST:process.env.NODE_ENV === 'development'
    // ? 'http://192.168.0.156:8099'  //本地
    ? 'https://chuangtou.hzgx.info/'  //正式

    : 'https://chuangtou.hzgx.info', //打包正式

}

